// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__OWgxF","box":"WorkspacesBox_box__2wz1H","node":"WorkspacesBox_node__3_Oek"};